export enum ModuleExecutorBoardTemplates {
  MODULE_LIBRARY = 'module-library',
}
